export default __webpack_public_path__ + "static/media/douchebags_logo_black.d036a511.png";